export default "__VITE_PUBLIC_ASSET__322be1ee__"